import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/new-risk.svg";
var NewRiskOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  NewRiskOutline_default as default
};
